import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ADD_INVENTORY_PATH } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';

export const useInventoryHeader = () => {
  const navigate = useNavigate();
  const goToAddInventory = useCallback(
    () => navigate(ADD_INVENTORY_PATH),
    [navigate]
  );

  const {
    userAccessRights: {
      Warehouse: { IsInventoryCreate },
    },
  } = useNewUserAccessRights();

  return { goToAddInventory, IsInventoryCreate };
};
